import * as React from 'react';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24" },
    React.createElement("circle", { cx: "12", cy: "12", r: "10", fill: "currentColor" }),
    React.createElement("circle", { cx: "12", cy: "12", r: "5", fill: "white" })), 'RadioChecked');
